import { render, staticRenderFns } from "./attach-file.vue?vue&type=template&id=27f7b4ea&scoped=true&"
import script from "./attach-file.vue?vue&type=script&lang=js&"
export * from "./attach-file.vue?vue&type=script&lang=js&"
import style0 from "./attach-file.vue?vue&type=style&index=0&id=27f7b4ea&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f7b4ea",
  null
  
)

export default component.exports